import { IFilterStateAction } from '../actions/filter-actions';
import { ActionType, ActionTypes } from '../../actions/index';
import { IFetchStateAction } from '../actions/filter-fetch';
import { ISeatMatchRequestModel } from '../../classes/request-model';
import { Level } from '../../classes/level';
import * as redux from 'redux';
import { map, find, sortBy, min, max } from 'lodash';
import { appSettingsModel } from '../../reducers/fetch-settings-reducer';
import { PriceType } from '../../classes/price-type';
import { SeatingOptionGroup } from '../../classes/seating-option';
import { findDefaultPriceType } from '../../helpers/price-type-helpers';

export interface IErrorModel {
    getAppSettingsFailed: boolean;
    getSeatmapFailed: boolean;
}

let defaultErrorModel = {
    getAppSettingsFailed: false,
    getSeatmapFailed: false,
}

export { defaultErrorModel };

export function errorModel(state: IErrorModel = defaultErrorModel, action: IFilterStateAction) {
    switch (action.type) {
        case ActionTypes.REQUEST_SEATMAP_ERROR:
            return { ...state, getSeatmapFailed: action.value };
        default:
            return state
    }
}

export interface IAdditionalSeatingOptionModel {
    additionalSeatingOptions: Array<SeatingOptionGroup>;
    renderAisleSeatToggle: boolean;
    allowAisleAccessSelected: boolean;
    additionalNotes: string;
}

let defaultAdditionalSeatingOptionModel = {

    additionalSeatingOptions: [],
    renderAisleSeatToggle: false,
    allowAisleAccessSelected: false,
    additionalNotes: ""

};

export { defaultAdditionalSeatingOptionModel };

export function additionalSeatingOptionModel(state: IAdditionalSeatingOptionModel = defaultAdditionalSeatingOptionModel, action: IFilterStateAction): IAdditionalSeatingOptionModel {
    switch (action.type) {
        case ActionTypes.UPDATE_ADDITIONAL_NOTES:
            return { ...state, additionalNotes: action.value }
        case ActionTypes.LOAD_ADDITIONAL_SEAT_REQUESTS:

            let combinedAdditionalSeatingOptions = action.value.additionalSeatingOptions.map((seatingOptionGroup) => {

                let _groupSeatSelectedQuantity = typeof (seatingOptionGroup.groupSeatSelectedQuantity) === "undefined" ? 0 : seatingOptionGroup.groupSeatSelectedQuantity;
                let _selectedSeatingOption = typeof (seatingOptionGroup.selectedSeatingOption) === "undefined" ? "" : seatingOptionGroup.selectedSeatingOption;
                let _isSelected = typeof (seatingOptionGroup.groupSelected) === "undefined" ? false : seatingOptionGroup.groupSelected;

                let _seatingOptions = seatingOptionGroup.options.map((seatingOption) => {
                    let _seatingOptionSelected = typeof (seatingOption.selected) === "undefined" ? false : seatingOption.selected;

                    return {
                        ...seatingOption,
                        selected: _seatingOptionSelected
                    };
                });

                return {
                    ...seatingOptionGroup,
                    groupSeatSelectedQuantity: _groupSeatSelectedQuantity,
                    selectedSeatingOption: _selectedSeatingOption,
                    groupSelected: _isSelected,
                    options: _seatingOptions
                };

            });

            if (action.value.renderAisleSeatToggle == "true") {
                return {
                    ...state,
                    additionalSeatingOptions: combinedAdditionalSeatingOptions,
                    renderAisleSeatToggle: true,
                };
            } else {
                return {
                    ...state,
                    additionalSeatingOptions: combinedAdditionalSeatingOptions,
                    renderAisleSeatToggle: false
                };
            }
        case ActionTypes.ADD_ADDITIONAL_SEATING_OPTION_IDS:
            const updatedSeatingOptionGroups = map(state.additionalSeatingOptions, (additionalSeatingOptionGroup) => {

                if (additionalSeatingOptionGroup.id == action.value.seatingOptionGroupId) {
                    //const options = _.uniqBy(action.value.selectedOptions.concat(additionalSeatingOptionGroup.options), 'id');
                    const updateSeatingOptions = map(additionalSeatingOptionGroup.options, (seatingOption) => {

                        let match = action.value.selectedOptions.filter(option => option.id == seatingOption.id);
                        if (match.length > 0) {
                            return { ...seatingOption, selected: match[0].selected };
                        } else {
                            return seatingOption;
                        }
                    });


                    return { ...additionalSeatingOptionGroup, options: updateSeatingOptions };
                } else {
                    return additionalSeatingOptionGroup;
                }

            });
            return { ...state, additionalSeatingOptions: updatedSeatingOptionGroups };
        case ActionTypes.ADD_ADDITIONAL_SEATING_OPTION_QUANTITY:
            const newSeatingOptionGroups = map(state.additionalSeatingOptions, (additionalSeatingOptionGroup) => {
                if (additionalSeatingOptionGroup.id == action.value.seatingOptionGroupId) {
                    return { ...additionalSeatingOptionGroup, groupSeatSelectedQuantity: action.value.quantity, groupSelected: true };
                } else {
                    return { ...additionalSeatingOptionGroup };
                }
            });
            return { ...state, additionalSeatingOptions: newSeatingOptionGroups };
        case ActionTypes.REMOVE_ADDITIONAL_SEATING_OPTION:

            const newSeatingOptions = map(state.additionalSeatingOptions, (additionalSeatingOption) => {
                if (additionalSeatingOption.id == action.value) {
                    return { ...additionalSeatingOption, groupSeatSelectedQuantity: 0, selectedSeatingOption: "", groupSelected: false };
                } else {
                    return additionalSeatingOption;
                }
            })
            return { ...state, additionalSeatingOptions: newSeatingOptions };
        case ActionTypes.CLEAR_ADDITIONAL_SEAT_REQUEST:
            const clearedSeatingOptions = map(state.additionalSeatingOptions, (additionalSeatingOption) => {
                return { ...additionalSeatingOption, groupSeatSelectedQuantity: 0, selectedSeatingOption: "" };
            });
            return {
                ...state,
                additionalSeatingOptions: clearedSeatingOptions,
                allowAisleAccessSelected: false
            };
        case ActionTypes.TOGGLE_AISLE_ACCESS:
            return { ...state, allowAisleAccessSelected: action.value };
        case ActionTypes.LOAD_LOCAL_STORAGE:
            return { ...state, ...action.value.additionalSeatingOptionModel };
        default:
            return state;
    }
}

export interface IPriceTypeFilterModel {
    priceTypes: Array<PriceType>;
}

let defaultPriceTypeFilterModel = { priceTypes: [] };

export { defaultPriceTypeFilterModel };

export function priceTypesModel(state: IPriceTypeFilterModel = defaultPriceTypeFilterModel, action: IFilterStateAction): IPriceTypeFilterModel {
    switch (action.type) {
        case ActionTypes.SELECT_PRICE_TYPE_TICKETS:
            const priceTypeId = action.value.priceTypeId;
            const selectedQuantity = action.value.quantity;

            const updatedPriceTypes = map(state.priceTypes, (priceType) => {
                if (priceType.priceTypeId == priceTypeId) {
                    return { ...priceType, selectedQuantity, selected: true };
                } else {
                    return priceType;
                }
            });

            return { ...state, priceTypes: updatedPriceTypes };
        case ActionTypes.LOAD_LOCAL_STORAGE:
            return { ...state, ...action.value.priceTypesModel };
        case ActionTypes.LOAD_PRICE_TYPES:
            if (action.value !== undefined) {
                // Create new array replacing config values on each existing price type in the state
                let priceTypes = (action.value.priceTypes as Array<PriceType>).map((priceType) => {
                    let oldPriceType = state.priceTypes.filter(oldPt => { return oldPt.priceTypeId == priceType.priceTypeId })[0];

                    if (oldPriceType !== undefined && oldPriceType.selectedQuantity > 0) {

                        delete priceType.selectedQuantity;
                        //console.log({ ...oldPriceType, ...priceType });
                    }

                    return { ...oldPriceType, ...priceType };
                });

                priceTypes = priceTypes.map(priceType => {
                    if (priceType.selectedQuantity === undefined) {
                        priceType.selectedQuantity = 0;
                    }

                    return priceType;
                });

                if (action.value.useOnlyPromoPriceType && action.value.priceTypes.filter(pt => pt.isPromo).length > 0) {
                    priceTypes = [getPromoPriceType(priceTypes)];
                }

                return { ...state, priceTypes };
            }
            return state;

        //case ActionTypes.SET_MAX_PRICE_TYPE_QUANTITY:
        //    return _.assign({}, state, {
        //        priceTypes: state.priceTypes.map(pt => {
        //            pt.maxQuantity = action.value;
        //            return pt;
        //        })
        //    });
        default:
            return state
    }
}

export interface IPerformanceDatesAndTimesModel {
    currentTime: string;
    currentDate: string;
    times: { [performanceId: number]: string };
    dates: { [performanceId: number]: string };
    dateTimes: { [performanceId: number]: string };
}

let defaultPerformanceDatesAndTimeModel = {
    currentTime: "",
    currentDate: "",
    times: {},
    dates: {},
    dateTimes: {}
};

export { defaultPerformanceDatesAndTimeModel };

export function performanceDatesAndTimesModel(state: IPerformanceDatesAndTimesModel = defaultPerformanceDatesAndTimeModel, action: IFetchStateAction): IPerformanceDatesAndTimesModel {
    switch (action.type) {
        case ActionTypes.LOAD_PERFORMANCE_DATES_AND_TIMES:
            return {
                ...state,
                currentTime: action.value.currentTime,
                currentDate: action.value.currentDate,
                times: action.value.times,
                dates: action.value.dates,
                dateTimes: action.value.dateTimes
            };
        default:
            return state;
    }
}


export interface IPriceRangeModel {
    //lowerSliderValue: number;
    //upperSliderValue: number;
    lowerRangeLimit: number;
    upperRangeLimit: number;
    rangeMinSpread: number;
    minPrice: number;
    maxPrice: number;
}

let defaultPriceRangeModel = {
    //lowerSliderValue: -1,
    //upperSliderValue: -1,
    lowerRangeLimit: -1,
    upperRangeLimit: -1,
    rangeMinSpread: 10,
    minPrice: 0,
    maxPrice: 0

};
export { defaultPriceRangeModel };

function getMinMin(priceTypes: PriceType[]) {
    return min(map(priceTypes, (pt: PriceType) => pt.minPrice));
}

function getMaxMax(priceTypes: PriceType[]) {
    return max(map(priceTypes, (pt: PriceType) => pt.maxPrice));
}

export function priceRangeModel(state: IPriceRangeModel = defaultPriceRangeModel, action: IFetchStateAction) {
    switch (action.type) {
        case ActionTypes.LOAD_DEFAULT_PRICE_RANGE:
            //const defaultPriceType = findDefaultPriceType(action.value.priceTypes as Array<PriceType>);
            //const minPrice = Math.floor(defaultPriceType === null ? getMinMin(action.value.priceTypes) : defaultPriceType.minPrice);
            //const maxPrice = Math.ceil(defaultPriceType === null ? getMaxMax(action.value.priceTypes) : defaultPriceType.maxPrice);

            const minPrice = Math.floor(getMinMin(action.value.priceTypes));
            const maxPrice = Math.ceil(getMaxMax(action.value.priceTypes));

            return {
                ...state,
                lowerRangeLimit: minPrice,
                minPrice: minPrice,
                maxPrice: maxPrice,
                upperRangeLimit: maxPrice
            };
        case ActionTypes.UPDATE_MIN_MAX_PRICE_RANGE:
            return {
                ...state,
                lowerRangeLimit: Math.floor(action.value.min.minPrice),
                upperRangeLimit: Math.ceil(action.value.max.maxPrice),
                minPrice: action.value.updatePriceRange ? action.value.min.minPrice : (state.minPrice == 0 ? action.value.min.minPrice : Math.max(Math.floor(action.value.min.minPrice), state.minPrice)),
                maxPrice: action.value.updatePriceRange ? action.value.max.maxPrice : (state.maxPrice == 0 ? action.value.max.maxPrice : Math.min(Math.ceil(action.value.max.maxPrice), state.maxPrice))
            };
        case ActionTypes.PRICE_RANGE_CLEAR:
            return { ...state, minPrice: action.value.minPrice, maxPrice: action.value.maxPrice };
        case ActionTypes.SELECT_MIN_PRICE:
            return { ...state, minPrice: action.value };
        case ActionTypes.SELECT_MAX_PRICE:
            return { ...state, maxPrice: action.value };
        case ActionTypes.LOAD_LOCAL_STORAGE:
            return { ...state, ...action.value.priceRangeModel };
        default:
            return state;


    }
}

function getPromoPriceType(priceTypes: PriceType[]): PriceType {
    let promoPriceTypes = priceTypes.filter(pt => pt.isPromo);
    if (promoPriceTypes.length > 0) {
        return sortBy(promoPriceTypes, 'minPrice')[0];
    }
    return null;
}

export interface IVenueLevelModel {
    venueLevels: Array<Level>;
}

let defaultVenueLevelModel = { venueLevels: [] };
export { defaultVenueLevelModel };

export function venueLevelModel(state: IVenueLevelModel = defaultVenueLevelModel, action: IFilterStateAction) {
    switch (action.type) {
        case ActionTypes.TOGGLE_VENUE_LEVEL:
            const levelNumber = action.value;

            const updatedLevels = map(state.venueLevels, (level) => {
                if (level.levelNumber === levelNumber) {
                    return { ...level, selected: !level.selected };
                } else {
                    return level;
                }
            });

            return { ...state, venueLevels: updatedLevels };
        case ActionTypes.SELECT_LEVEL:

            const levelId = action.value;

            const newLevels = map(state.venueLevels, (level: Level) => {
                if (level.id === levelId) {
                    return { ...level, selected: true };
                } else {
                    return { ...level, selected: false };
                }
            });

            return { ...state, venueLevels: newLevels };
        case ActionTypes.RESET_VENUE_LEVELS:
            return {
                ...state,
                venueLevels: map(state.venueLevels, (level) => {
                    level.selected = false;
                    return level;
                })
            };
        case ActionTypes.LOAD_LOCAL_STORAGE:
            return { ...state, ...action.value.venueLevelModel };
        case ActionTypes.LOAD_VENUE_LEVELS:
            // Create new array replacing config values on each existing venue levels in the state

            const venueLevels = action.value.map((level: Level) => {
                return {
                    ...level,
                    disabled: level.availableCount === 0,
                    selected: level.selected && level.availableCount > 0
                };
            });

            return { ...state, venueLevels };
        default:
            return state
    }
}

